import { SelectorEntities } from 'shared/entities/components/Selector';
import { TFunctionType } from 'shared/entities/localization';

import {
  BlockBaseServer,
  BlockKind,
  BlockType,
  EditableAttrsBlockServer
} from '../common';

export enum HttpRequestPayloadKind {
  form = 'form',
  json = 'json',
  json_sq = 'json_sq',
  plain = 'plain'
}

export const httpRequestPayloadKindOrder = [
  HttpRequestPayloadKind.form,
  HttpRequestPayloadKind.json,
  HttpRequestPayloadKind.json_sq,
  HttpRequestPayloadKind.plain
];

export const httpRequestPayloadKindEntities: SelectorEntities<HttpRequestPayloadKind> =
  httpRequestPayloadKindOrder.reduce<SelectorEntities<HttpRequestPayloadKind>>(
    (acc, kind) => ({
      ...acc,
      [kind]: {
        id: kind,
        title: (t: TFunctionType): string =>
          t(`block.ActionHttpRequest.payloadKind.${kind}`, {
            ns: 'entities'
          })
      }
    }),
    {} as SelectorEntities<HttpRequestPayloadKind>
  );

export type ActionHttpRequestFormPayloadServer = {
  kind: HttpRequestPayloadKind.form;
  data: Record<string, string>;
};

export type ActionHttpRequestJsonPayloadServer = {
  kind: HttpRequestPayloadKind.json;
  data: string;
};

export type ActionHttpRequestJsonSqPayloadServer = {
  kind: HttpRequestPayloadKind.json_sq;
  data: string;
};

export type ActionHttpRequestPlainPayloadServer = {
  kind: HttpRequestPayloadKind.plain;
  data: string;
};

export type ActionHttpRequestResponseServer = {
  headers_var: string;
  body_var: string;
  status_var: string;
};

export enum ActionHttpRequestMethod {
  GET = 'get',
  POST = 'post',
  PATCH = 'patch',
  DELETE = 'delete',
  PUT = 'put',
  HEAD = 'head'
}

export const mapHttpRequestMethodToTitle = {
  [ActionHttpRequestMethod.POST]: 'POST',
  [ActionHttpRequestMethod.GET]: 'GET',
  [ActionHttpRequestMethod.PATCH]: 'PATCH',
  [ActionHttpRequestMethod.DELETE]: 'DELETE',
  [ActionHttpRequestMethod.PUT]: 'PUT',
  [ActionHttpRequestMethod.HEAD]: 'HEAD'
};

export const httpRequestMethodOrder = [
  ActionHttpRequestMethod.GET,
  ActionHttpRequestMethod.POST,
  ActionHttpRequestMethod.PATCH,
  ActionHttpRequestMethod.DELETE,
  ActionHttpRequestMethod.PUT,
  ActionHttpRequestMethod.HEAD
];

export type ActionHttpRequestHeadersServer = Record<string, string>;

export type ActionHttpRequestParamsServer = {
  method: ActionHttpRequestMethod;
  url: string;
  payload:
    | ActionHttpRequestFormPayloadServer
    | ActionHttpRequestJsonPayloadServer
    | ActionHttpRequestJsonSqPayloadServer
    | ActionHttpRequestPlainPayloadServer;
  response: ActionHttpRequestResponseServer;
  headers: ActionHttpRequestHeadersServer;
};

export type ActionHttpRequestServer = BlockBaseServer<
  BlockType.action,
  BlockKind.httpRequest
> &
  EditableAttrsBlockServer<ActionHttpRequestParamsServer>;
